import React from "react";
import { useLang } from "@/i18n/LanguageContext";

export default function FAQ() {
  const { t } = useLang();
  const items = t("faq.items");

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-cream-100 py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <span className="text-[11px] uppercase tracking-[0.32em] text-gold-deep font-medium">
            {t("faq.overline")}
          </span>
          <h2 className="mt-6 font-serif text-4xl sm:text-5xl leading-[1.05] text-olive-900 font-medium">
            {t("faq.h2_a")} <span className="italic">{t("faq.h2_b")}</span> {t("faq.h2_c")}
          </h2>
          <p className="mt-6 text-olive-800/80 font-light leading-relaxed">
            {t("faq.helper_pre")}
            <a
              href="mailto:info@cortijodesantamaria.com"
              className="underline decoration-gold underline-offset-4 hover:text-olive-900"
            >
              info@cortijodesantamaria.com
            </a>
            {t("faq.helper_post")}
          </p>
        </div>

        <div className="lg:col-span-8" data-testid="faq-list">
          <dl className="border-t border-cream-400">
            {items.map((item, i) => (
              <div
                key={item.q}
                data-testid={`faq-item-${i}`}
                className="py-8 lg:py-10 border-b border-cream-400 grid md:grid-cols-[auto_1fr] gap-4 md:gap-8"
              >
                <dt className="md:w-16 text-[10px] uppercase tracking-[0.3em] text-olive-800/50 pt-1">
                  0{i + 1}
                </dt>
                <div>
                  <dt className="font-serif text-xl sm:text-2xl text-olive-900 leading-snug">
                    {item.q}
                  </dt>
                  <dd className="mt-3 text-olive-800/85 font-light leading-relaxed text-base">
                    {item.a}
                  </dd>
                </div>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
